// 坐标点样式
import { Circle as CircleStyle, Fill, Stroke, Style } from "ol/style";
import Icon from "ol/style/Icon";

// 坐标点样式

export const PointDangerStyle = new Style({
  image: new Icon({
    anchor: [0.5, 1], //锚点
    opacity: 1,
    scale: 1,
    src: require("../icon/points/pointDanger.png"), //图标的URL
  }),
});
export const zd= new Style({
  image: new Icon({
    anchor: [0.5, 1], //锚点
    opacity: 1,
    scale: 0.5,
    src: require("../../../assets/images/logisticsServices/zd.png"), //图标的URL
  }),
});
export const qd= new Style({
  image: new Icon({
    anchor: [0.5, 1], //锚点
    opacity: 1,
    scale: 0.5,
    src: require("../../../assets/images/logisticsServices/qd.png"), //图标的URL
  }),
});
export const Pointyuan= new Style({
  image: new Icon({
    anchor: [0.5, 1], //锚点
    opacity: 1,
    scale: 0.5,
    src: require("../../../assets/images/logisticsServices/yuan1.png"), //图标的URL
  }),
});
export const PointInfoStyle = new Style({
  image: new Icon({
    anchor: [0.5, 1], //锚点
    opacity: 1,
    scale: 1,
    src: require("../icon/points/pointInfo.png"), //图标的URL
  }),
});

export const PointPrimaryStyle = new Style({
  image: new Icon({
    anchor: [0.5, 1], //锚点
    opacity: 1,
    scale: 1/1.5,
    src: require("../icon/points/pointPrimary.png"), //图标的URL
  }),
});

export const PointSuccessStyle = new Style({
  image: new Icon({
    anchor: [0.5, 1], //锚点
    opacity: 1,
    scale: 1,
    src: require("../icon/points/pointSuccess.png"), //图标的URL
  }),
});

export const PointWarningStyle = new Style({
  image: new Icon({
    anchor: [0.5, 1], //锚点
    opacity: 1,
    scale: 1,
    src: require("../icon/points/pointWarning.png"), //图标的URL
  }),
});

export const PointIconStyle = new Style({
  image: new Icon({
    anchor: [0.5, 1], //锚点
    opacity: 1,
    scale: 1,
    src: require("../icon/points/pointIcon0.png"), //图标的URL 种植基地
  }),
});
export const PointIconStyle1 = new Style({
  image: new Icon({
    anchor: [0.5, 1], //锚点
    opacity: 1,
    scale: 1,
    src: require("../icon/points/pointIcon1.png"), //图标的URL 养殖基地
  }),
});
export const PointIconStyle2 = new Style({
  image: new Icon({
    anchor: [0.5, 1], //锚点
    opacity: 1,
    scale: 1,
    src: require("../icon/points/pointIcon2.png"), //图标的URL 加工基地
  }),
});
export const PointIconStyle3 = new Style({
  image: new Icon({
    anchor: [0.5, 1], //锚点
    opacity: 1,
    scale: 1,
    src: require("../icon/points/pointIcon3.png"), //图标的URL 仓储基地
  }),
});

// 基站样式

export const SiteDangerStyle = new Style({
  image: new Icon({
    anchor: [0.5, 1], //锚点
    opacity: 1,
    scale: 1,
    src: require("../icon/sites/siteDanger.png"), //图标的URL
  }),
});

export const SiteInfoStyle = new Style({
  image: new Icon({
    anchor: [0.5, 1], //锚点
    opacity: 1,
    scale: 1,
    src: require("../icon/sites/siteInfo.png"), //图标的URL
  }),
});

export const SitePrimaryStyle = new Style({
  image: new Icon({
    anchor: [0.5, 1], //锚点
    opacity: 1,
    scale: 1,
    src: require("../icon/sites/sitePrimary.png"), //图标的URL
  }),
});

export const SiteSuccessStyle = new Style({
  image: new Icon({
    anchor: [0.5, 1], //锚点
    opacity: 1,
    scale: 1,
    src: require("../icon/sites/siteSuccess.png"), //图标的URL
  }),
});

export const SiteWarningStyle = new Style({
  image: new Icon({
    anchor: [0.5, 1], //锚点
    opacity: 1,
    scale: 1,
    src: require("../icon/sites/siteWarning.png"), //图标的URL
  }),
});

export const SiteCustomStyle = new Style({
  image: new Icon({
    anchor: [0.5, 1], //锚点
    opacity: 1,
    scale: 1,
    src: require("../icon/sites/siteWarning.png"), //图标的URL
  }),
});


// 点标识样式

export const PointStyle = function (color, radius) {
  return new Style({
    image: new CircleStyle({
      fill: new Fill({
        color: color,
      }),
      radius: radius,
    }),
  });
};

// 覆盖圆样式

export const CircleCustomStyle = function (color) {
  return new Style({
    fill: new Fill({
      color: color,
    }),
  });
};

// 鼠标绘制覆盖物样式

export const DrawStyle = new Style({
  fill: new Fill({
    color: "#ffcc33",
  }),
  stroke: new Stroke({
    color: "#409eff",
    width: 3,
  }),
  image: new CircleStyle({
    radius: 3,
    fill: new Fill({
      color: "#ffcc33",
    }),
  }),
});

// 多边形样式

export const PolygonStyle = new Style({
  fill: new Fill({
    color: "rgba(255, 255, 255, 0.3)",
  }),
  stroke: new Stroke({
    color: "#67c23a",
    width: 3,
  }),
});

// 绿色扇形标识
export const SectorGreenStyle = function (type='green', angle = 0) {
  return new Style({
    image: new Icon({
      anchor: [0.5, 1], //锚点
      scale: 0.25,
      opacity: 0.7,
      rotation: angle * (Math.PI / 180),
      src: type == 'green' ? require("../icon/sector/green.png") : require("../icon/sector/blue.png") //图标的URL
    }),
  });
};

